import { 
    // GET_DSR_FAQ_CONTENT_FAILURE, 
    // GET_DSR_FAQ_CONTENT_REQUEST, 
    // GET_DSR_FAQ_CONTENT_SUCCESS,
    MANAGE_DSR_FAQ_CONTENT_REQUEST,
    MANAGE_DSR_FAQ_CONTENT_SUCCESS,
    MANAGE_DSR_FAQ_CONTENT_FAILURE,
    RESET_MANAGE_DSR_FAQ_CONTENT
} from '../../actions/dsr-faq-actions-type';


// const INITIAL_STATE_GET_DSR_FAQ_CONTENT = { results: "" }


// export function getDsrFaqContentReducer(state = INITIAL_STATE_GET_DSR_FAQ_CONTENT, action) {
//     switch (action.type) {
//         case GET_DSR_FAQ_CONTENT_REQUEST:
//             return { ...state, isLoading: true, results: "" };
//         case GET_DSR_FAQ_CONTENT_SUCCESS:
//             return { ...state, isLoading: false, results: action.payload };
//         case GET_DSR_FAQ_CONTENT_FAILURE:
//             return { ...state, isLoading: false, error: 'Error trying to get DSR FAQ content' };
//         default:
//             return state;
//     }
// }


const INITIAL_STATE_MANAGE_DSR_FAQ_CONTENT = { results: "" }


export function manageDsrFaqContentReducer(state = INITIAL_STATE_MANAGE_DSR_FAQ_CONTENT, action) {
    switch (action.type) {
        case RESET_MANAGE_DSR_FAQ_CONTENT:
            return INITIAL_STATE_MANAGE_DSR_FAQ_CONTENT;
        case MANAGE_DSR_FAQ_CONTENT_REQUEST:
            return { ...state, isLoading: true, results: "" };
        case MANAGE_DSR_FAQ_CONTENT_SUCCESS:
            return { ...state, isLoading: false, results: action.payload };
        case MANAGE_DSR_FAQ_CONTENT_FAILURE:
            return { ...state, isLoading: false, error: 'Error trying to manage DSR FAQ content' };
        default:
            return state;
    }
}